import { useEffect, useState } from "react";
import { useRouter } from "next/router";
import axios from "axios";
import { features } from "../main_page/EntryBlock/constants";
import Link from "next/link";
import { HandySvg } from "handy-svg";
import Image from "next/image";
import style from "./tryOurTools.module.scss";

const TryOurTools = ({ t }) => {
	const { pathname } = useRouter();
	const [listData, setListData] = useState([]);

	useEffect(
		() => {
			const getToolsData = async () => {
				const { data } = await axios.get(`https://cms.bgrem.ai/api/services?filters[url_name]=${pathname.replace("/", "")}&populate=deep,2`);

				const actualToolList = data?.data[0]?.attributes?.service?.data?.map((item) => item?.attributes?.url_name) || [];

				const filteredFeatures = features.filter((item) => actualToolList.some((element) => item?.link_url?.includes(element)));

				setListData(filteredFeatures);
			};

			getToolsData();
		},
		// eslint-disable-next-line
		[pathname]
	);

	if (listData.length < 1) return <></>;

	return (
		<section className={style.section}>
			<h3 className={style.title}>{t["discover_more_ai"] || "Try our tools"}</h3>
			<div className={style.serviceWrapper}>
				{listData.map((feature) => (
					<Link key={feature.name} href={feature.link_url} className={style.features_item}>
						<Image className={style.item_img} src={`/header/service/${feature.description}.png`} alt={feature.name} width={362} height={336} quality={98} loading="lazy" />
						<div className={style.item_text}>
							{t[feature.name]} <HandySvg src="/illustration_service/back.svg" width={24} height={24} className={style.item_next} />
						</div>
					</Link>
				))}
			</div>
		</section>
	);
};

export default TryOurTools;
